/*
  NordiskPuls - gave-motor
  =================================================================
  Produktbestemte gaver. Reglerne staar IKKE her - de staar paa
  produkterne i Shopify som metafelter:
    custom.gave_produkt    hvilket produkt kunden faar
    custom.gave_rabatkode  ordre-rabatten der goer den gratis
    custom.gave_maks       hvor mange pr. ordre (tomt = 1)
  En ny gave oprettes ved at udfylde felterne. Ingen kode.

  TO BETINGELSER skal begge vaere opfyldt:
    1. kunden har TAGET IMOD gaven (se np-gaveflag.js)
    2. et produkt med en gave-regel ligger i kurven

  BEMAERK at 1 ikke er "vi kender kundens mail". Det er ikke nok at
  Klaviyo genkender browseren - gaven skal vaere taget imod med et klik.
  Ellers er popup'en bare en notits om noget der allerede er sket, og saa
  mister vi baade "Gave modtaget"-eventen og chancen for at gen-tilmelde
  en kunde der var faldet af listen. Hvem der genkendes bestemmer kun
  HVILKEN popup der vises - se np-gavepopup.js.

  FORHOLDET TIL NAESESTRIPS-GAVEN
  Naesestrips styres af en beloebstaerskel (1.300 kr) i np-cart-drawer-
  logic.js og har intet med denne fil at goere. De to holdes fra hinanden
  paa _gavetype: produktgaver har den, naesestrips har den ikke.

  RABATKODEN ER EN TOSIDET FORPLIGTELSE - begge fejl har vaeret her:
   1. Den skal vaere bekraeftet aktiv FOER gaven lagges i. Ellers betaler
      kunden for en linje der staar til 0 kr.
   2. Den skal ryddes NAAR den sidste gave forsvinder. Ellers faar kunden
      49 kr rabat uden gave.
  Og oprydningen skal ligge EFTER "lag gaven i" i synk() - ligger den
  foer, rydder motoren op i stedet for at lagge gaven i.

  HASTIGHED - MAALT 23/9-2026 paa produktsiden, desktop, hurtig linje:
    cart/add.js  1.162-1.428 ms
    cart.js        388-1.005 ms
    discount/...  1.082 ms
  Gaven landede 3.676 ms efter klikket paa "Laeg i indkoebskurv" - og det
  var BEDSTE tilfaelde, hvor rabatkoden allerede sad paa kurven. Tre ting
  er lavet om:

   a) Hvilke rabatkoder der ligger paa kurven, renderes nu serverside i
      #NPGaveExtra. Foer blev /cart.js hentet for at faa det samme at
      vide - hver gang, ogsaa ved hver oprydning.

   b) /discount/<kode>?redirect=/cart.js ENDER i /cart.js og svarer med
      den friske kurv. Foer blev det svar smidt vaek og kurven hentet
      igen bagefter. En hel rundtur for ingenting.

   c) Gavelinjen tegnes med det samme, i graat, ud fra navn/pris/billede
      i #NPGaveExtra. Serveren indhenter. Popup'en har lige sagt "vi
      lagger gaven i kurven" - saa skal den ogsaa VAERE der, ikke komme
      fire sekunder senere.
*/
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var KAMPAGNE = 'np_kampagnekode';
  var VORES_KODER = 'np_gavekoder';
  var MAERKE = 'https://cdn.shopify.com/s/files/1/0892/4269/8075/files/Design_uden_navn_-_2026-03-18T141318.852.png?v=1773814404';
  // NP 7.7 (4/10): G2-gaven (streg + lys flade) som i kurven – erstatter det farvede PNG i gave-maerket.
  var MAERKE_SVG = '<svg class="np-gave-ikon" viewBox="3 3.7 18 18" width="20" height="20" fill="none" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><defs><linearGradient id="npGaveLG" gradientUnits="userSpaceOnUse" x1="3" y1="3" x2="21" y2="21"><stop offset="0" stop-color="#4794c2"/><stop offset="1" stop-color="#1d5a84"/></linearGradient><linearGradient id="npGaveLF" x1="0" y1="0" x2="1" y2="1"><stop offset=".3" stop-color="#e9f3fd" stop-opacity="0"/><stop offset=".7" stop-color="#d4e7f7"/><stop offset="1" stop-color="#c2dcf2"/></linearGradient></defs><path d="M4.5 10.5h15v8.5a1.5 1.5 0 0 1-1.5 1.5H6a1.5 1.5 0 0 1-1.5-1.5z" fill="url(#npGaveLF)"/><g stroke="url(#npGaveLG)" stroke-width="1.4"><path d="M4.5 10.5h15v8.5a1.5 1.5 0 0 1-1.5 1.5H6a1.5 1.5 0 0 1-1.5-1.5z"/><path d="M3.5 7.5h17v3h-17z"/><path d="M12 7.5v13"/><path d="M12 7.5c-1.3-3-4.8-3.4-4.8-1.3S10.3 7.5 12 7.5zM12 7.5c1.3-3 4.8-3.4 4.8-1.3S13.7 7.5 12 7.5z"/></g></svg>';
  var arbejder = false;

  /* ---------- Koder vi selv har sat paa ---------- */

  // Kan ikke udledes af de aktuelle regler: er udloeser-produktet fjernet
  // fra kurven, er reglen ogsaa vaek - og saa ville koden blive haengende.
  function huskKode(k) {
    if (!k) return;
    try {
      var l = JSON.parse(sessionStorage.getItem(VORES_KODER) || '[]');
      if (l.indexOf(k) === -1) { l.push(k); sessionStorage.setItem(VORES_KODER, JSON.stringify(l)); }
    } catch (e) {}
  }
  function voresKoder() {
    try { return JSON.parse(sessionStorage.getItem(VORES_KODER) || '[]'); } catch (e) { return []; }
  }

  // Der findes intet rabatkode-felt i kurv-skuffen, saa de eneste koder paa
  // sessionen er vores egne ELLER en kode fra et kampagnelink (?discount=).
  // En rydning fjerner ALLE indtastede koder, saa kampagnekoden huskes og
  // saettes paa igen. Automatiske rabatter (fx "Gratis Naesestrips")
  // rammes ikke - de regner sig selv ud igen.
  (function huskKampagnekode() {
    try {
      var k = new URLSearchParams(location.search).get('discount');
      if (k) sessionStorage.setItem(KAMPAGNE, k);
    } catch (e) {}
  })();

  /* ---------- Har kunden taget imod? ---------- */

  function harTagetImod() {
    return !!(window.npGaveFlag && window.npGaveFlag.har());
  }

  // Kaldes af gave-popup'en (kendt kunde trykker "Tag imod") og af
  // Klaviyo-formularen (ukendt kunde afgiver mail) via klaviyoForms-eventet.
  window.npGaveMail = function () {
    if (window.npGaveFlag) window.npGaveFlag.gem();
    synk();
  };

  /* ---------- Kunden har sagt nej tak ----------
     Selve lagringen ligger i np-gaveflag.js, saa motoren og popup'en
     laeser det SAMME svar. Havde de hver sin kopi, kunne popup'en tro at
     kunden havde sagt nej mens motoren troede det modsatte - og saa ville
     gaven lande i kurven uden at nogen havde spurgt om den. */

  function erAfvist(u) {
    return !!(window.npGaveAfvist && window.npGaveAfvist.er(u));
  }
  window.npGaveAfvis = function (u) {
    if (window.npGaveAfvist) window.npGaveAfvist.saet(u);
  };

  /* ---------- Kurv-hjaelpere ---------- */

  function post(path, body) {
    return fetch(ROOT + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) throw new Error(d.description || d.message || 'Kurv-fejl');
        return d;
      });
    });
  }

  function hentKurv() { return fetch(ROOT + 'cart.js').then(function (r) { return r.json(); }); }

  function tegnKurvOm(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var inder = document.querySelector('.drawer__inner');
    var nyInder = doc.querySelector('.drawer__inner');
    if (inder && nyInder) inder.innerHTML = nyInder.innerHTML;
    ['cart-drawer', 'cart-drawer-items'].forEach(function (sel) {
      var nu = document.querySelector(sel), ny = doc.querySelector(sel);
      if (nu && ny) nu.classList.toggle('is-empty', ny.classList.contains('is-empty'));
    });
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  function tegnOm(data) {
    if (data && data.sections && data.sections['cart-drawer']) {
      tegnKurvOm(data.sections['cart-drawer']);
      return Promise.resolve();
    }
    return fetch(ROOT + 'cart?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (s) { if (s['cart-drawer']) tegnKurvOm(s['cart-drawer']); });
  }

  function laesJson(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function laesData() { return laesJson('NPGaveData'); }
  function laesExtra() { return laesJson('NPGaveExtra') || { koder: [], vis: {}, gratis: '0' }; }

  /* ---------- Den midlertidige gavelinje ---------- */

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function fjernSkelet() {
    var s = document.querySelector('.np-gaveskelet');
    if (s) s.remove();
  }

  // Tegnes med det samme og bliver staaende indtil kurven gen-renderes -
  // enten fordi gaven landede (saa erstattes den af den rigtige linje),
  // eller fordi det gik galt (saa fjernes den, se tilfoej()).
  // Bevidst uden farvevaelger og skraldespand: den maa ikke kunne klikkes
  // paa, for der er ikke noget bag den endnu.
  function visSkelet(regel, extra) {
    var v = extra.vis && extra.vis[String(regel.udloeser)];
    var tbody = document.querySelector('cart-drawer .cart-items tbody');
    if (!v || !tbody || document.querySelector('.np-gaveskelet')) return;

    var tr = document.createElement('tr');
    tr.className = 'cart-item np-gruppe np-gavelinje np-gaveskelet';
    tr.setAttribute('role', 'row');
    tr.setAttribute('aria-busy', 'true');
    tr.style.opacity = '0.55';
    tr.innerHTML =
      '<td class="cart-item__media" role="cell">' +
        (v.billede
          ? '<img class="cart-item__image" src="' + esc(v.billede) + '" alt="" width="75" height="75">'
          : '') +
      '</td>' +
      '<td class="cart-item__details" role="cell" colspan="3">' +
        '<div class="cart-item__info-top"><div class="cart-item__title-wrap">' +
          '<span class="cart-item__name">' + esc(v.titel) + ' (Gave)</span>' +
          '<div class="np-gavemaerke">' +
            MAERKE_SVG + '<span>Gratis gave</span>' +
          '</div>' +
          '<div class="cart-item__price-inline">' +
            '<strong>' + esc(extra.gratis) + '</strong>' +
            (v.pris ? '<s>' + esc(v.pris) + '</s>' : '') +
          '</div>' +
        '</div></div>' +
      '</td>';
    tbody.insertBefore(tr, tbody.firstChild);
  }

  /* ---------- Rabatkoden ---------- */

  // Ligger PRAECIS denne kode paa kurven? Det er ikke nok at spoerge "er
  // der en ordrerabat" - der kan ligge andre, fx den automatiske "Gratis
  // Naesestrips". For en kodebaseret rabat er title i cart.js selve koden.
  function harKoden(cart, kode) {
    var k = String(kode).trim().toLowerCase();
    return (cart.cart_level_discount_applications || []).some(function (d) {
      return String(d.title || '').trim().toLowerCase() === k;
    });
  }

  function iListen(koder, kode) {
    var k = String(kode).trim().toLowerCase();
    return (koder || []).indexOf(k) !== -1;
  }

  // Svaret ER kurven: ruten ender i /cart.js efter omdirigeringen.
  function saetKode(kode) {
    return fetch(ROOT + 'discount/' + encodeURIComponent(kode) + '?redirect=/cart.js')
      .then(function (r) { return r.json(); });
  }

  function sikrRabat(kode, koder) {
    if (!kode) return Promise.resolve(true);

    // #NPGaveExtra er renderet af SAMME kurv som gave-reglerne vi lige har
    // handlet paa. Er koden der, er den der - og saa er der ingen grund
    // til at spoerge serveren om det samme igen.
    if (iListen(koder, kode)) { huskKode(kode); return Promise.resolve(true); }

    return saetKode(kode)
      .catch(function () { return hentKurv(); })
      .then(function (frisk) {
        var ok = harKoden(frisk, kode);
        if (ok) huskKode(kode);
        return ok;
      });
  }

  function ryddGavekoder(koder) {
    var mine = voresKoder();
    if (!mine.length) return Promise.resolve();
    // Ingen af vores koder ligger paa kurven -> intet at rydde, og ingen
    // grund til at hente /cart.js for at faa det bekraeftet.
    if (!mine.some(function (k) { return iListen(koder, k); })) return Promise.resolve();

    return post('cart/update.js', { discount: '' }).then(function () {
      try { sessionStorage.removeItem(VORES_KODER); } catch (e) {}
      var kamp = null;
      try { kamp = sessionStorage.getItem(KAMPAGNE); } catch (e) {}
      if (kamp) return saetKode(kamp);
    }).then(function () { return tegnOm(null); });
  }

  /* ---------- Selve synkroniseringen ---------- */

  /* ---------- For mange gaver? ----------
     TO KILDER TIL FOR MANGE, begge maalt 24/9:

     a) TO FANER. Kunden har produktsiden aaben i to faner - almindeligt
        naar man sammenligner eller midterklikker sig frem. Begge faner
        laeser deres EGET server-renderede #NPGaveData, begge ser "ingen
        gave endnu", og begge lagger en i. Resultat: to covers, een rabat,
        og kunden betaler 39 kr ekstra mens der staar "Gratis gave, 0 kr".
        'arbejder' hjaelper ikke - den er pr. dokument, ikke pr. browser.

     b) Nogen skruer antallet op ad anden vej. Der er ingen antalsvaelger
        paa gavelinjen, saa det kraever en cart/change.js udenom - men
        motoren skal ikke stole paa at ingen goer det.

     Derfor klippes der ned til maks ved hver synk. Det er et sikkerhedsnet
     bagefter; laasen nedenfor forsoeger at undgaa det i foerste omgang.
  */
  function saetAntal(gave, antal) {
    return post('cart/change.js', { id: gave.key, quantity: antal, sections: 'cart-drawer' }).then(tegnOm);
  }

  function forMange(oensket, data) {
    var maksFor = {};
    oensket.forEach(function (r) { maksFor[r.udloeser] = r.maks || 1; });
    for (var i = 0; i < data.gaver.length; i++) {
      var g = data.gaver[i];
      var maks = maksFor[g.udloeser];
      if (maks && g.antal > maks) return { gave: g, maks: maks };
    }
    return null;
  }

  /* Tvaer-fane-laas. localStorage deles mellem faner i samme browser;
     sessionStorage goer ikke. Seks sekunder er rigeligt til en
     cart/add.js (maalt 1,2-1,4 sek) og kort nok til at en fane der
     doer midt i det ikke blokerer gaven for altid. */
  var LAAS = 'np_gave_arbejder';

  function laasTaget() {
    try {
      var t = parseInt(localStorage.getItem(LAAS) || '0', 10);
      return t > Date.now() - 6000;
    } catch (e) { return false; }
  }
  function tagLaas() {
    try { localStorage.setItem(LAAS, String(Date.now())); } catch (e) {}
  }
  function slipLaas() {
    try { localStorage.removeItem(LAAS); } catch (e) {}
  }

  /* ---------- Koden kan forsvinde uden at gaven goer det ----------
     Den anden halvdel af den tosidede forpligtelse. oprydning() daekker
     "gave vaek -> kode vaek". Det her daekker det omvendte: "kode vaek,
     gave bliver".

     MAALT 24/9: kunden kan fjerne rabatkoden i checkout med eet klik paa
     krydset ved siden af kodens navn. Goer hun det, staar der stadig
     "Gratis gave - 0 kr" i kurv-skuffen, men hun bliver opkraevet 49 kr.
     Skaermen lyver om prisen, og motoren opdagede det aldrig, fordi
     sikrRabat KUN blev kaldt naar en gave skulle lagges i.

     Hvorfor kun eet forsoeg pr. kode pr. sidevisning: slaar Shopify
     koden fra af en grund vi ikke kender (udloebet, markedsbegraenset,
     minimumsbeloeb ikke naaet), skal vi ikke hamre paa /discount i en
     uendelig loekke. Een advarsel i konsollen, saa er det godt.
  */
  var genforsoegt = {};

  function sikrKoderPaaPlads(data, extra) {
    if (arbejder || !data.gaver.length) return false;

    var regelFor = {};
    data.regler.forEach(function (r) { regelFor[r.udloeser] = r; });

    var mangler = null;
    for (var i = 0; i < data.gaver.length; i++) {
      var r = regelFor[data.gaver[i].udloeser];
      if (!r || !r.kode) continue;
      if (iListen(extra.koder, r.kode)) continue;
      if (genforsoegt[r.kode]) continue;
      mangler = r;
      break;
    }
    if (!mangler) return false;

    genforsoegt[mangler.kode] = true;
    arbejder = true;
    sikrRabat(mangler.kode, extra.koder)
      .then(function (ok) {
        if (!ok) {
          console.warn('[NP gave] "' + mangler.kode + '" kunne ikke saettes paa igen - gaven staar til 0 kr men koster penge');
        }
        return tegnOm(null);
      })
      .catch(function (e) { console.error('[NP gave]', e); })
      .then(function () { arbejder = false; });
    return true;
  }


  // Ingen gaver tilbage? Saa maa koden heller ikke ligge der.
  // Kaldes KUN naar der ikke er noget at lagge i - ellers ville motoren
  // rydde op i stedet for at give kunden gaven.
  function oprydning(data, extra) {
    if (data.gaver.length || arbejder) return;
    arbejder = true;
    ryddGavekoder(extra.koder)
      .catch(function (e) { console.error('[NP gave]', e); })
      .then(function () { arbejder = false; });
  }

  function synk() {
    // npGaveLaas saettes af farvevaelgeren, mens den bytter farve paa en
    // gavelinje. I det oejeblik er gaven fjernet og den nye farve endnu
    // ikke lagt i - uden laasen ville vi lagge en gave nummer to i.
    if (arbejder || window.npGaveLaas) return;
    var data = laesData();
    if (!data) return;
    var extra = laesExtra();

    var oensket = data.regler.filter(function (r) { return !erAfvist(r.udloeser); });
    var gyldige = {};
    oensket.forEach(function (r) { gyldige[r.udloeser] = r; });

    var forAeldede = data.gaver.filter(function (g) { return !gyldige[g.udloeser]; });
    if (forAeldede.length) {
      arbejder = true;
      fjern(forAeldede[0])
        .then(function () { arbejder = false; synk(); })
        .catch(function (e) { console.error('[NP gave]', e); arbejder = false; });
      return;
    }

    // For mange gaver klippes ned FOER der overvejes at lagge flere i.
    var forMeget = forMange(oensket, data);
    if (forMeget) {
      arbejder = true;
      saetAntal(forMeget.gave, forMeget.maks)
        .then(function () { arbejder = false; synk(); })
        .catch(function (e) { console.error('[NP gave]', e); arbejder = false; });
      return;
    }

    var harAllerede = {};
    data.gaver.forEach(function (g) { harAllerede[g.udloeser] = (harAllerede[g.udloeser] || 0) + g.antal; });
    var mangler = oensket.filter(function (r) { return (harAllerede[r.udloeser] || 0) < (r.maks || 1); });

    if (!mangler.length || !harTagetImod()) {
      // Gaven er der - men ligger koden der stadig? Se sikrKoderPaaPlads.
      if (sikrKoderPaaPlads(data, extra)) return;
      oprydning(data, extra);
      return;
    }

    // Lagger en anden fane allerede gaven i? Saa lad vaere - ellers
    // ender vi med to. Proev igen om et oejeblik.
    if (laasTaget()) { setTimeout(synk, 1500); return; }

    arbejder = true;
    tagLaas();
    tilfoej(mangler[0], extra)
      .then(function () { slipLaas(); arbejder = false; synk(); })
      .catch(function (e) { console.error('[NP gave]', e); slipLaas(); fjernSkelet(); arbejder = false; });
  }

  function tilfoej(regel, extra) {
    visSkelet(regel, extra);
    return sikrRabat(regel.kode, extra.koder).then(function (ok) {
      if (!ok) {
        console.warn('[NP gave] rabatkoden "' + regel.kode + '" kunne ikke saettes - gaven lagges IKKE i');
        fjernSkelet();
        return;
      }
      return post('cart/add.js', {
        items: [{
          id: regel.variant,
          quantity: 1,
          properties: { _is_gift: 'true', _gavetype: String(regel.udloeser) }
        }],
        sections: 'cart-drawer'
      }).then(tegnOm);
    });
  }

  function fjern(gave) {
    return post('cart/change.js', { id: gave.key, quantity: 0, sections: 'cart-drawer' })
      .then(tegnOm)
      .catch(function () {
        return hentKurv().then(function (cart) {
          var l = cart.items.find(function (it) {
            return it.properties && it.properties._gavetype == gave.udloeser;
          });
          if (!l) return;
          return post('cart/change.js', { id: l.key, quantity: 0, sections: 'cart-drawer' }).then(tegnOm);
        });
      });
  }

  /* ---------- Kunden fjerner gaven selv ---------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.np-gave-fjern');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var udloeser = btn.dataset.udloeser;
    window.npGaveAfvis(udloeser);
    var raekke = btn.closest('.cart-item');
    if (raekke) { raekke.style.opacity = '0.35'; raekke.style.pointerEvents = 'none'; }
    var data = laesData();
    var gave = data && data.gaver.find(function (g) { return String(g.udloeser) === String(udloeser); });
    if (!gave) return;
    arbejder = true;
    fjern(gave).finally(function () { arbejder = false; });
  });

  /* ---------- Hvornaar koerer den ----------
     80 ms og ikke 250: forsinkelsen er der kun for at samle flere
     cart:updated i traek til eet kald. Det goer 80 ms lige saa godt som
     250 - og de 170 ms laa midt i den ventetid kunden maerkede. */

  var timer = null;
  function planlaeg() { clearTimeout(timer); timer = setTimeout(synk, 80); }

  document.addEventListener('cart:updated', planlaeg);
  document.addEventListener('DOMContentLoaded', planlaeg);
  planlaeg();
})();
